import defaultTheme from './defaultTheme';
import NdsThemeProviderBaseHoc from './NdsThemeProviderBaseHoc';
const NdsThemeProviderDefault = NdsThemeProviderBaseHoc(defaultTheme);
export { NdsThemeProviderDefault as NdsThemeProviderRootComp };
export default NdsThemeProviderDefault;
//# sourceMappingURL=NdsThemeProvider.js.map